import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `RenameCommand` is the command used to rename an entry.
 * `RenameCommand` is valid if the selection contains exactly one
 * entry which can be renamed.
 */
export default class RenameCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._newName = "";
	}

	newName() {
		return this._newName;
	}

	setNewName(newValue) {
		this._newName = newValue;
	}

	accept(aVisitor) {
		return aVisitor.visitRenameCommand(this);
	}

	requireRefresh() {
		return true;
	}

	priority() {
		return 200;
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	_performOnService(callback) {
		this._documentService.executeRenameCommand(this, callback);
	}

	_execute() {
		const entry = this.getEntry();
		entry.setName(this._newName);
	}

	static isApplicable() {
		return (
			selection.isSingleSelection() &&
			selection.firstEntry().canBeRenamed()
		);
	}
}
